import { Outlet } from 'react-router-dom';
import Sidebar from './Sidebar';
import Header from './Header';
import FloatingChatWidget from '../chat/FloatingChatWidget';

export default function AppLayout() {
    return (
        <div className="min-h-screen bg-gray-50 dark:bg-gray-950 text-gray-900 dark:text-gray-100">
            <Sidebar />
            <Header />
            <main className="ml-64 pt-16 p-6">
                <Outlet />
            </main>
            <FloatingChatWidget />
        </div>
    );
}
